import {
  Directive,
  Input,
  ElementRef,
  TemplateRef,
  ViewContainerRef,
  ComponentRef,
  OnInit
} from '@angular/core';
import { AuthService } from '../services/auth.service';
import { AccessLevels } from '../models/access-levels';
import { DisabledFieldsetComponent } from '../components/disabled-fieldset/disabled-fieldset.component';

@Directive({
  selector: '[hasPermission]',
  standalone: false
})
export class HasPermissionDirective {
  private disabledFieldset: ComponentRef<DisabledFieldsetComponent>;

  constructor(
    private authService: AuthService,
    private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  @Input() set hasPermission(permissions: string | string[]) {
    // if user has write access to any of the permissions, display editable content
    // else if user has read acces to any of the permissions, display read only content
    let write = false;
    let read = false;

    if (typeof permissions === 'string') {
      permissions = [permissions];
    }

    permissions.forEach(role => {
      if (this.authService.hasPermission(role, AccessLevels.Write)) {
        write = true;
      } else if (this.authService.hasPermission(role, AccessLevels.Read)) {
        read = true;
      }
    });

    if (write) {
      // display editable content
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else if (read) {
      // put content in a disabled fieldset for read only view
      this.disabledFieldset = this.viewContainer.createComponent(DisabledFieldsetComponent);
      this.disabledFieldset.instance.template = this.templateRef;
    } else {
      // user does not have read or write permissions. hide content
      this.viewContainer.clear();
    }
  }
}
